// variant of src/components/shared/production-listings/component.tsx

import React, { useContext } from 'react'

import { Box, Column, ComponentList, Grid, Row, Text } from '@vividseats/vivid-ui-kit'

import LazyLoadedProductionListings from '@/components/shared/lazy-loaded-production-listings'
import OverFiltered from '@/components/shared/over-filtered'
import ProductionsRowsContext from '@/context/productions-rows'
import { AnalyticsSubIds } from '@/context/utils/analytics'
import { useTrackViewProductionList } from '@/hooks/use-analytics'

import VenueProductionListing from '../venue-production-listing'

import styles from './styles.module.scss'

interface Props {
    title?: string
}

const VenueProductionListings: React.FC<Props> = ({ title }) => {
    const {
        state: { fetching },
        selectors: { productions, visibleByDefaultProductionsWithFormat, showProductionsData, hasFiltersApplied },
    } = useContext(ProductionsRowsContext)

    useTrackViewProductionList(!fetching, productions, AnalyticsSubIds.VariantProductionList)

    return (
        <div>
            {title && (
                <Grid>
                    <Row className={styles.row} align="end">
                        <Column className={styles.title} pl={0.5} mb={0.5}>
                            <Text as="h3" size="xl" weight="bold" altFont>
                                {title}
                            </Text>
                        </Column>
                    </Row>
                </Grid>
            )}

            {showProductionsData ? (
                <Box marginBottom={7}>
                    {/* Render up to 10 production listings that are always visible */}
                    <ComponentList
                        Component={VenueProductionListing}
                        componentPropsList={visibleByDefaultProductionsWithFormat}
                    />

                    <LazyLoadedProductionListings productionListingComponents={{ desktop: VenueProductionListing }} />
                </Box>
            ) : (
                hasFiltersApplied && <OverFiltered withDivider={false} withBottomPadding />
            )}
        </div>
    )
}

export default VenueProductionListings
